import React, {useState} from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Swal from 'sweetalert2'
import axios from 'axios';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://balastik.com/">
        Hüseyin Bal
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const defaultTheme = createTheme();

export default function Login({ setUser, user, setIsAdmin }) {

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    // const csvUrl = 'https://sheetdb.io/api/v1/8kpchs3qqicvh';

    // axios.get(csvUrl)    // Use Axios to fetch the CSV data
    //     .then((response) => {
    //       const currentUser = response.data.find(user => user.kullanıcıAdı === data.get('username') && user.sifre === data.get('password')) 

    //       if (currentUser) {
    //         setUser(currentUser)
    //         setIsAdmin(currentUser.admin === '1')
    //       } else {
    //         Swal.fire({
    //           icon: "error",
    //           title: "Kullanıcı Bulunamadı",
    //           text: "Kullanıcı adı veya şifre hatalı!",
    //           backdrop: `
    //           rgba(0,0,0,0.7)
    //         `
    //         });
    //       }
    //     })
    //     .catch((error) => {
    //         console.error('Error fetching CSV data:', error);
    //     });

        const url = "https://next-pro-nine-rho.vercel.app/api/users";

        // GET isteği yaparak veriyi al
        fetch(url)
          .then(response => {
            // Yanıtın durumunu kontrol et
            if (response.ok) {
              return response.json();
            }
            throw new Error('Hata! İstek başarısız. Durum kodu: ' + response.status);
          })
          .then(values => {
            const sheetUsers = [];
            const columnNames = values[0];
            const columnIndices = {};
            
            columnNames.forEach((name, index) => {
              columnIndices[name] = index;
            });
            
            values.slice(1).forEach(row => {
              const userData = {};
              columnNames.forEach((name, index) => {
                userData[name] = index < row.length ? row[index] : '';
              });
              sheetUsers.push(userData);
            });



            const currentUser = sheetUsers.find(user => user.kullanıcıAdı === data.get('username') && user.sifre === data.get('password')) 

            if (currentUser) {
              setUser(currentUser)
              setIsAdmin(currentUser.admin === '1')
            } else {
              Swal.fire({
                icon: "error",
                title: "Kullanıcı Bulunamadı",
                text: "Kullanıcı adı veya şifre hatalı!",
                backdrop: `
                rgba(0,0,0,0.7)
              `
              });
            }
    
            // **
    
          })
          .catch(error => {
            console.error(error); // Hata durumunda hatayı yakalayıp yazdırın
          });
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ 
        height: '100vh',
         }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            // backgroundImage: 'url(https://www.fia.com/sites/default/files/styles/content_details/public/news/main_image/capture_decran_2023-10-10_a_13.11.00.png?itok=Ba_ub73G)',
            backgroundImage: 'url(https://images.pexels.com/photos/2922140/pexels-photo-2922140.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)',
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              py: 8,
              px: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100vh',
              backgroundColor: '#f3ecff'
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              B2B Balastik Portal
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label="Kullanıcı Adı"
                name="username"
                autoComplete="username"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Şifre"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              {/* <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              /> */}
              <Button
                type="submit"
                fullWidth
                variant="outlined"
                sx={{ mt: 3, mb: 2, p:2 }}
              >
                Giriş Yap
              </Button>
              {/* <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2">
                    Forgot password?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="#" variant="body2">
                    {"Don't have an account? Sign Up"}
                  </Link>
                </Grid>
              </Grid> */}
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}